import { Button } from '@bennows/boows-react';
import { useTranslation } from 'react-i18next';
import { useSignOut } from './useSignOut';

/** Full page (spec 140 REQ-140-021): Bennows suspended the active tenant; contact and signing out are the ways on. */
export function TenantSuspended() {
  const { t } = useTranslation();
  const signOut = useSignOut();
  return (
    <main id="main" className="ui-auth" tabIndex={-1}>
      <section className="ui-card ui-auth__card ui-error-state" role="alert">
        <h1>{t('account.suspended.title')}</h1>
        <p className="ui-error-state__text">{signOut.isError ? t('account.signOutFailed') : t('account.suspended.text')}</p>
        <p className="ui-error-state__text">{t('account.suspended.contact')}</p>
        <Button variant="secondary" block loading={signOut.isPending} onClick={() => signOut.mutate()}>
          {t('account.signOut')}
        </Button>
      </section>
    </main>
  );
}
